import htmx from 'htmx.org'

/**
 * Glue for the "Offerte aanvragen" modal in the cart summary.
 *
 * The button and form use htmx to load their fragments into the shared remote modal. htmx does not swap 4xx
 * responses by default, while the server answers 422 for an invalid form or a cart below the threshold.
 */

/**
 * The element that issued the request. htmx dispatches most request events on that element, but `htmx:beforeSwap`
 * on the swap target (the shared modal content), so `detail.elt` alone can't tell whose response it is.
 */
const requestElement = (event) => event.detail.requestConfig?.elt ?? event.detail.elt

const isQuotationRequest = (event) => {
  const elt = requestElement(event)

  return elt instanceof Element && elt.closest('[data-quotation-request]') !== null
}

const showTemplate = (selector) => {
  const content = document.querySelector('[data-remote-modal-content]')
  const template = document.querySelector(selector)

  if (content && template instanceof HTMLTemplateElement) {
    content.replaceChildren(template.content.cloneNode(true))
  }
}

htmx.on('htmx:beforeRequest', (event) => {
  // Only the button (GET) starts with an empty modal; the form disables its submit button instead
  if (isQuotationRequest(event) && !(requestElement(event) instanceof HTMLFormElement)) {
    showTemplate('[data-remote-modal-loading-template]')
  }
})

htmx.on('htmx:beforeSwap', (event) => {
  // Swap the form with its errors or the "unavailable" notice. Clearing isError also keeps htmx from firing
  // htmx:responseError afterwards, so showError below only sees real failures (5xx).
  if (isQuotationRequest(event) && event.detail.xhr.status === 422) {
    event.detail.shouldSwap = true
    event.detail.isError = false
  }
})

const showError = (event) => {
  if (isQuotationRequest(event)) {
    showTemplate('[data-remote-modal-error-template]')
  }
}

htmx.on('htmx:responseError', showError)
htmx.on('htmx:sendError', showError)
